import React from "react";
import { Paper, Typography, makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  yearHeaderPaper: {
    display: "inline-block",
    padding: theme.spacing(1, 2),
    borderRadius: 20,
    backgroundColor: theme.palette.grey[100],
  },
}));

export default function YearHeader({ year }) {
  const classes = useStyles();

  return (
    <Paper className={classes.yearHeaderPaper} elevation={0}>
      <Typography variant="subtitle1">ปีน้ำ {year}</Typography>
    </Paper>
  );
}
